// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__IEeZR","modal":"Modal_modal__znUym","btn":"Modal_btn__X5ofL"};